import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Modal from "../Modal";
import { sendGetRequest } from "../../utils";
import { useEffect, useState } from "react";
import moment from "moment-timezone";

const ResidentLogs = ({ openLogs, onClose, selectedResident }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLogs = async () => {
    try {
      setLoading(true);
      const response = await sendGetRequest(
        `residents/checkin/${selectedResident.id}`,
        true
      );
      if (response.ok) {
        const data = await response.json();
        setLogs(data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedResident) {
      fetchLogs();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedResident]);

  return (
    <Modal
      open={openLogs}
      handleClose={onClose}
      style={{ width: "620px", backgroundColor: "#f5f5f5" }}
    >
      <div>
        <div className="flex items-center justify-between">
          <Typography variant="h6">Daily Visits</Typography>
        </div>
        <TableContainer component={Paper} className="mt-4">
          <Table aria-label="checkin logs" size="small">
            <TableHead>
              <TableRow>
                <TableCell className="!font-semibold min-w-[76px] max-w-[76px]">
                  Week
                </TableCell>
                <TableCell className="!font-semibold min-w-[224px] max-w-[224px]">
                  Date
                </TableCell>
                <TableCell className="!font-semibold min-w-[134px] max-w-[134px]">
                  Weekly Streak
                </TableCell>
                <TableCell className="!font-semibold min-w-[110px] max-w-[110px]">
                  Discount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={4} className="text-center">
                    <div className="text-center w-full">Loading...</div>
                  </TableCell>
                </TableRow>
              ) : logs.length > 0 ? (
                logs.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>{moment(row.created_at).format("W")}</TableCell>
                    <TableCell component="th" scope="row">
                      {moment(row.created_at).format(
                        "ddd, MMMM D, YYYY hh:mm A"
                      )}
                    </TableCell>
                    <TableCell>{row.current_streak}</TableCell>
                    <TableCell>
                      {Number(row.discount).toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                      })}
                      % Off
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} className="text-center">
                    <div className="text-center">No logs found</div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <div className="flex justify-end mt-4">
          <Button variant="outlined" size="small" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ResidentLogs;
